export default __webpack_public_path__ + "static/media/programme-grenoble.af24bdf4.pdf";